import { Component, Injector, Input } from '@angular/core';
import { NavigationService } from '@home/services';

@Component({
  selector: 'app-change-password-instruction',
  templateUrl: './change-password-instruction.component.html',
  styleUrls: ['./change-password-instruction.component.css'],
})
export class ChangePasswordInstructionComponent {
  @Input('mailEncrypted') mailEncrypted: string;

  private readonly navigationService: NavigationService;

  constructor(private injector: Injector) {
    this.navigationService = this.injector.get(NavigationService);
  }

  public redirectToLogin() {
    this.navigationService.redirectToLogin();
  }
}
